import React, { useEffect, useRef } from 'react'
import { useState } from 'react'
import { postData } from '../../../Service/ApiMethod'
import { Selected_Candidate } from '../../../Service/service'
import { useTranslation } from "react-i18next";


const RoundsPopup = (props) => {
  // const [selectedcandidate, setSelectedCandidate] = useState()
  const [roundStatus, setRoundStatus] = useState()
  // const [secondround, setSecondRound] = useState()
  // const [selectedround, setSelectedRound] = useState()
  // const [rejectedround, setRejectedRound] = useState()
  const [seekerID, setSeekerID] = useState()

  let SeekerID = props?.unlockId || props?.seekerID
  const popup = props?.popup
  console.log(props?.unlockId, props?.seekerID,'SeekerID', SeekerID && SeekerID)

  // const name= props?.name

  const closeRoundPopup = props?.closePopup || props?.setRoundPopup

  // const status = props?.userDetails?.round_status


  const getSeekerId = ()=>{
    setSeekerID(SeekerID)
  }
  
  const reff = useRef(null);
    useOutsideAlerter(reff);
  
    function useOutsideAlerter(ref) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            closeRoundPopup && closeRoundPopup(false)
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }

  // const handleclick = (roundName, seekerid) => {
  //   let objdata = {
  //     // seeker_id: SeekerID,
  //     seeker_id: seekerid,
  //     round_status: roundName,
  //   }
  //   console.log('objdata', objdata)

  //   if (status?.toUpperCase() == roundName?.toUpperCase()) {
  //     if (status == 'Rejected') {
  //       alert("Candidate is already Rejected")
  //     } else if (status == "Selected") {
  //       alert("Candidate is already selected ")
  //     } else {
  //       alert(`Candidate is already in ${roundName}`)
  //     }
  //   } else {
  //     if (roundName == "Rejected") {
  //       alert("Candidate is Rejected")
  //     } else if (roundName == "Selected") {
  //       alert("Candidate has been Selected ")
  //     } else {
  //       // alert(`Candidate is selected in ${roundName}`)
  //       postData(objdata, Selected_Candidate)
  //   .then((response) => response.json())
  //   .then((data) => {
  //     alert(data.message)
  //     if(data?.error_message){
  //     console.log(data?.error_message)
  //     alert(data?.error_message)
  //     }else{
  //       alert(`Candidate is selected in ${roundName}`)
  //     }
  //   })
  //   .catch((err) => {
  //     console.log('error', err)
  //     // console.log('code error', err)
  //   })
  //     }
  //   }
  // closeRoundPopup && closeRoundPopup(false)
  // }

  const handleclick = (roundName, seekerid) => {
    var result = window.confirm("Are you sure you want to proceed?");
    if(result){
      let objdata = {
        // seeker_id: SeekerID,
        seeker_id: SeekerID.user == undefined ? SeekerID:SeekerID.user,
        round_status: roundName,
      }
      console.log(SeekerID,'objdata22222222', objdata)
  
      postData(objdata, Selected_Candidate)
      .then((response) => response.json())
      .then((data) => {
        console.log('round response', data)
        if(data?.status_code==200){
          alert(data?.message)
          props?.setPopup(!popup)
        }else{
          console.log(data?.error_message)
          alert(data?.error_message)
        }
      })
      .catch((err) => {
        console.log('error', err)
      })
      
    closeRoundPopup && closeRoundPopup(false)
    }
   
  }

  // const PopUp = (roundName) => {
  //   if (status != roundName) {
  //     if (roundName == "Rejected") {
  //       alert("Candidate is Rejected")
  //     } else if (roundName == "Selected") {
  //       alert("Candidate has been Selected ")
  //     } else {
  //       alert(`Candidate is selected in ${roundName}`)
  //     }
  //   } else {
  //     if (status == 'Rejected') {
  //       alert("Candidate is already Rejected")
  //     } else if (status == "Selected") {
  //       alert("Candidate is already selected ")
  //     } else {
  //       alert(`Candidate is already in ${roundName}`)
  //     }
  //   }
  // }
  // const handlefirstclick = (round) => {
  //   let objdata = {
  //     seeker_id: SeekerID,
  //     round_status: round,
  //   }
  //   postData(objdata, Selected_Candidate)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data)
  //     })
  //     .catch((err) => {
  //       console.log('error', err)
  //       console.log('code error', err)
  //       alert(err.error_message)
  //     })
  //     closeRoundPopup(false)
  // }

  // const handleSecondclick = (round) => {
  //   let objdata = {
  //     seeker_id: SeekerID,
  //     round_status: round,
  //   }
  //   postData(objdata, Selected_Candidate)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data)
  //     })
  //     .catch((err) => {
  //       console.log('error', err)
  //       console.log('code error', err)
  //     })
  //     closeRoundPopup(false)
  // }

  // const handleRejectedclick = (round) => {
  //   let objdata = {
  //     seeker_id: SeekerID,
  //     round_status: round,
  //   }
  //   postData(objdata, Selected_Candidate)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data)
  //     })
  //     .catch((err) => {
  //       console.log('error', err)
  //       // console.log('code error', err)
  //       alert(err?.error_message)
  //     })
  //     closeRoundPopup(false)
  // }

  // const handleSlectedclick= (round) => {
  //   let objdata = {
  //     seeker_id: SeekerID,
  //     round_status: round,
  //   }
  //   postData(objdata, Selected_Candidate)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data)
  //     })
  //     .catch((err) => {
  //       console.log('error', err)
  //       console.log('code error', err)
  //     })
  //     closeRoundPopup(false)
  // }

  useEffect(() => {
    getSeekerId()
  }, [])

  const {t} = useTranslation();

  return (
    <>
 <div className="blur-screen-full-area inner-modal  flex-center">
        <div className="add-to-list-box" ref={reff} >
          <div className="text-center">
            <p className="heading mt-2">{t('Select Rounds')}</p> 
            {/* <h3>{name && name}</h3> */}
          </div>

          <div
            className="space-between d-flex my-2"
            // onClick={(e) =>{
            //   e.stopPropagation()
            //   handlefirstclick(SeekerID)
            // }}
          >
            <button
              className="text btn-none"
              // onChange={(e) => setRoundStatus(e.target.value)}
            >
              {t('First Round')}
            </button>
            <button className="toggle-btn">
              <img
                src="../images/plus.png"
                name="First Round"
                onClick={(e) => {
                  // e.stopPropagation()
                  setRoundStatus(e.target.name)
                  // handlefirstclick(e.target.name)
                  handleclick(e.target.name, seekerID)
                }}
                alt=""
              />
            </button>
          </div>

          <hr className="line" />

          <div
            className="space-between d-flex my-2"
            // onClick={(e) =>{
            //   e.stopPropagation()
            //   handleSecondclick(SeekerID)
            // } }
          >
            <button
              className="text btn-none"
              // onChange={(e) =>{
              //   setSecondRound(e.target.value)
              // } }
            >
              {t('Second Round')}
            </button>
            <button className="toggle-btn">
              <img
                src="../images/plus.png"
                name="Second Round"
                onClick={(e) => {
                  // e.stopPropagation()
                  setRoundStatus(e.target.name)
                  // handleSecondclick(e.target.name)
                  // handleclick(e.target.name)
                  handleclick(e.target.name, seekerID)
                }}
                alt=""
              />
            </button>
          </div>

          <hr className="line" />

          <div
            className="space-between d-flex my-2"
            // onClick={(e) =>{
            //   e.stopPropagation()
            //   handleclick(SeekerID)}}
          >
            <button
              className="text btn-none"
              // onChange={(e) => setSelectedRound(e.target.value)}
            >
              {t('Selected')}
            </button>
            <button className="toggle-btn">
              <img
                src="../images/plus.png"
                name="Selected"
                onClick={(e) => {
                  // e.stopPropagation()
                  setRoundStatus(e.target.name)
                  // handleSlectedclick(e.target.name)
                  // handleclick(e.target.name)
                  handleclick(e.target.name, seekerID)
                }}
                alt=""
              />
            </button>
          </div>

          <hr className="line" />

          <div
            className="space-between d-flex my-2"
            // onClick={(e) =>{
            //   e.stopPropagation()
            //   handleRejectedclick()
            // }}
          >
            <button
              className="text btn-none"
              // onChange={(e) => setRejectedRound(e.target.value)}
            >
              {t('Rejected')}
            </button>
            <button className="toggle-btn">
              <img
                src="../images/plus.png"
                name="Rejected"
                onClick={(e) => {
                  // e.stopPropagation()
                  setRoundStatus(e.target.name)
                  // handleRejectedclick(e.target.name)
                  // handleclick(e.target.name)
                  handleclick(e.target.name, seekerID)
                }}
                alt=""
              />
            </button>
          </div>

          <hr className="line" />

          {/* <button className="theme-btn w-100" onClick={(e)=>{
            e.stopPropagation()
            if(!roundStatus){
              alert('Please Select round')
            } else {
              closeRoundPopup && closeRoundPopup(false)
            }
            }}>
            Done
          </button> */}
        </div>
      </div>
    </>
  )
}

export default RoundsPopup




// ---------------------------New Code------------------------------

// ---------------------------New Code------------------------------

